import { Card } from "primereact/card";
import { ProgressBar } from "primereact/progressbar";
import { Chart } from "primereact/chart";
import "../css/dashboard.css";
import useCountUp from "../hook/useCountUp";

export default function Dashboard() {

    /* ===== BAR CHART ===== */
    const barChartData = {
        labels: [
            "Russia", "India", "Germany", "South Korea", "Japan",
            "UK", "France", "Canada", "USA", "Netherlands", "China", "Spain"
        ],
        datasets: [
            {
                data: [211, 228, 1044, 1054, 1303, 1530, 1760, 1798, 2154, 2178, 2540, 4085],
                backgroundColor: [
                    "#8b5cf6", "#fb7185", "#fbbf24", "#1e3a8a",
                    "#86efac", "#8b5cf6", "#1e3a8a", "#fb7185",
                    "#1e3a8a", "#fbbf24", "#fb7185", "#86efac"
                ],
                borderRadius: 2,
                borderSkipped: false,
                barThickness: 60,         
                maxBarThickness: 80
            }
        ]
    };

    const barChartOptions = {
        maintainAspectRatio: false,
        animation: {
            duration: 1600,
            easing: "easeOutCubic"        
        },
        plugins: {
            legend: { display: false }
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: {
                    color: "#94a3b8",
                    font: { size: 12 }
                }
            },
            y: {
                grid: {
                    color: "#eef2ff",
                    drawBorder: false
                },
                ticks: {
                    color: "#94a3b8",
                    font: { size: 12 }
                },
                beginAtZero: true
            }
        }
    };


    return (
        <div className="dashboard-container">

            {/* ===== STATS ===== */}
            <div className="stats-grid">
                <Stat
                    title="Revenue"
                    value="$35000"
                    badge="Today"
                    percent={95}
                    color="#3b82f6"
                />
                <Stat
                    title="Orders"
                    value="35000"
                    badge="This Week"
                    percent={65}
                    color="#fbbf24"
                />
                <Stat
                    title="Leads"
                    value="$50000"
                    badge="This Month"
                    percent={75}
                    color="#22c55e"
                />
                <Stat
                    title="Lead Conversion Rate"
                    value="50%"
                    badge="Annual"
                    percent={85}
                    color="#8b5cf6"
                />
            </div>

            {/* ===== MAIN GRID ===== */}
            <div className="dashboard-grid">

                {/* PAYMENT HISTORY */}
                <Card className="dashboard-card large-card">
                    <div className="card-header">
                        <span className="card-title">Payment History</span>
                        <i className="pi pi-ellipsis-v card-menu" />
                    </div>

                    <div className="card-divider" />

                    <div className="chart-area">
                        <Chart
                            type="bar"
                            data={barChartData}
                            options={barChartOptions}
                            height={330}
                        />
                    </div>
                </Card>

                {/* USD TO EURO */}
                <Card className="dashboard-card side-card">
                    <div className="card-header">
                        <span className="card-title">1 United States Dollar Equals</span>
                        <i className="pi pi-ellipsis-v card-menu" />
                    </div>

                    <div className="card-divider" />

                    <h2 className="currency-value">0.50 Euro</h2>
                    <p className="muted">24 Apr 6:00 am UTC Declaration</p>

                    <div className="currency-grid">
                        <div className="currency-box">
                            <span>United State</span>
                            <strong>1</strong>
                        </div>
                        <div className="currency-box">
                            <span>Euro</span>
                            <strong className="green">0.50</strong>
                        </div>
                    </div>
                </Card>

            </div>
        </div>
    );
}

/* ===== STAT CARD ===== */
function Stat({ title, value, subtext, percent }) {
    const numericValue = parseInt(value.replace(/[^0-9]/g, ""));
    const animatedValue = useCountUp(numericValue);

    return (
        <Card className="stat-card">
            <div className="flex justify-between items-start">
                <div>
                    <span className="stat-title">{title}</span>

                    <h3>
                        {value.includes("$") && "$"}
                        {animatedValue.toLocaleString()}
                        {value.includes("%") && "%"}
                    </h3>

                    <p className="stat-sub">{subtext}</p>
                </div>

                <span className="stat-pill">{percent}%</span>
            </div>

            <ProgressBar value={percent} showValue={false} />
        </Card>
    );
}
